import { userPrivacySetting } from '@/Models';
import { consentManager } from './ConsentManager';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';

/**
 * @param {string} key
 * @param {string|number|boolean|Array<string|number|boolean>} value
 */
function setClarityTag(key, value) {
    if (value === null || value === undefined || value === '') {
        return;
    }

    window.clarity('set', key, Array.isArray(value) ? value.map(String) : String(value));
}

/**
 * @param {object} pluginConfig
 * @param {string} pluginConfig.id - Clarity project ID
 */
export default function clarityPlugin(pluginConfig) {
    consentManager.register(analyticsPluginName.clarity, userPrivacySetting.analytic, () => {
        window.clarity = window.clarity || function() {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.clarity.ms/tag/${pluginConfig.id}`;
        document.head.appendChild(script);
    });

    return {
        name: analyticsPluginName.clarity,
        config: pluginConfig,
        track: () => {},
        trackTo: ({ event, properties = {} }) => {
            if (typeof window.clarity !== 'function') {
                return;
            }

            Object.entries(properties).forEach(([key, value]) => {
                setClarityTag(key, value);
            });

            window.clarity('event', event);
        },
    };
}
